/* eslint-disable */
export default {
  unknown: 'Onbekend',
  anonymous: 'Anoniem',
  activeCall: 'Actieve oproep',
} as const;

// @key: @#@"unknown"@#@ @source: @#@"Unknown"@#@
// @key: @#@"anonymous"@#@ @source: @#@"Anonymous"@#@
// @key: @#@"activeCall"@#@ @source: @#@"Active Call"@#@
